import { defineComponent as C, ref as P, onBeforeUpdate as D, h as v } from "vue";
import { useCarouselContext as b } from "./ghl-ui.es926.js";
import k from "./ghl-ui.es854.js";
import { indexMap as N } from "./ghl-ui.es939.js";
const _ = {
  total: {
    type: Number,
    default: 0
  },
  currentIndex: {
    type: Number,
    default: 0
  },
  dotType: {
    type: String,
    default: "dot"
  },
  trigger: {
    type: String,
    default: "click"
  },
  keyboard: Boolean
}, A = C({
  name: "CarouselDots",
  props: _,
  setup(o) {
    const {
      mergedClsPrefixRef: i
    } = k(o), r = P([]), t = b();
    function a(e, n) {
      switch (e.key) {
        case "Enter":
        case " ":
          e.preventDefault(), t.to(n);
          return;
      }
      o.keyboard && p(e);
    }
    function h(e) {
      o.trigger === "hover" && t.to(e);
    }
    function m(e) {
      o.trigger === "click" && t.to(e);
    }
    function p(e) {
      var n;
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey)
        return;
      const c = (n = document.activeElement) === null || n === void 0 ? void 0 : n.nodeName.toLowerCase();
      if (c === "input" || c === "textarea")
        return;
      const {
        code: s
      } = e, y = s === "PageUp" || s === "ArrowUp", g = s === "PageDown" || s === "ArrowDown", x = s === "PageUp" || s === "ArrowRight", w = s === "PageDown" || s === "ArrowLeft", d = t.isVertical(), u = d ? y : x, f = d ? g : w;
      !u && !f || (e.preventDefault(), u && !t.isNextDisabled() ? (t.next(), l(t.currentIndexRef.value)) : f && !t.isPrevDisabled() && (t.prev(), l(t.currentIndexRef.value)));
    }
    function l(e) {
      var n;
      (n = r.value[e]) === null || n === void 0 || n.focus();
    }
    return D(() => r.value.length = 0), {
      mergedClsPrefix: i,
      dotEls: r,
      handleKeydown: a,
      handleMouseenter: h,
      handleClick: m
    };
  },
  render() {
    const {
      mergedClsPrefix: o,
      dotEls: i
    } = this;
    return v("div", {
      class: [`${o}-carousel__dots`, `${o}-carousel__dots--${this.dotType}`],
      role: "tablist"
    }, N(this.total, (r) => {
      const t = r === this.currentIndex;
      return v("div", {
        "aria-selected": t,
        ref: (a) => i.push(a),
        role: "button",
        tabindex: "0",
        class: [`${o}-carousel__dot`, t && `${o}-carousel__dot--active`],
        key: r,
        onClick: () => {
          this.handleClick(r);
        },
        onMouseenter: () => {
          this.handleMouseenter(r);
        },
        onKeydown: (a) => {
          this.handleKeydown(a, r);
        }
      });
    }));
  }
});
export {
  A as default
};
